import * as React from 'react';
import * as _ from 'lodash';
import { ICategoryResult, ITerm } from '../../state-helpers/categories';

export interface ICategoryTermProps {
    category: ICategoryResult;
    term: ITerm;
    categories: ICategoryResult[];
    onUpdateSearchCategory(categories: ICategoryResult[]): void;
}

export class CategoryTerm extends React.Component<ICategoryTermProps, any> {

    categoryTermChange(e) {
        var categoryList = _.cloneDeep(this.props.categories);

        for (var f = 0; f < categoryList.length; f++) {
            for (var i = 0; i < categoryList[f].terms.length; i++) {
                if (categoryList[f].terms[i].id === this.props.term.id) {
                    categoryList[f].terms[i].selected = !this.props.term.selected;
                }
            }
        }

        this.props.onUpdateSearchCategory(categoryList);
    }

    render() {
        //Don't show hits with 0 results or no text. If facet is Policy Types, show them all anyway
        if (!this.props.term.alwaysShow &&
            (this.props.term.hits === 0 || this.props.term.term === ''))
            return null;

        var bindCategoryTermChange = this.categoryTermChange.bind(this);

        var filterValue = this.props.term.term.replace(/\s+/g, '-').toLowerCase();
        return (
            //Apply disabled styling to hits with alwaysShow === true and 0 hits
            <div className={'form-element-checkbox' + (this.props.term.alwaysShow && this.props.term.hits === 0 ? ' form-element-checkbox-disabled' : '')}>
                <input type="checkbox" id={filterValue} name={filterValue} value={filterValue} className="form-element-checkbox" checked={this.props.term.selected} onClick={bindCategoryTermChange}
                    disabled={this.props.term.alwaysShow && this.props.term.hits === 0} />
                <label htmlFor={filterValue}>

                    <svg className="svg-icon selected" aria-hidden="true" focusable="false">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-checkbox-selected" />
                    </svg>

                    <svg className="svg-icon unselected" aria-hidden="true" focusable="false">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-checkbox-unselected" />
                    </svg>
                </label>
                <div className="form-element-checkbox-text">
                    <p className="form-element-checkbox-text-term">{this.props.term.displayTerm}</p>
                    <p className="form-element-checkbox-text-number"><span className="search-facet-item-number">({this.props.term.hits})</span></p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/categories/category-term.tsx